import React from 'react';
import { motion } from 'motion/react';
import { pageVariants, sectionVariants } from '../../../animations/variants';
import {
  Paper,
} from '@mui/material';
import {
  Cloud as CloudIcon,
} from '@mui/icons-material';
import { getPortalUser } from '../../../services/portalApi';
import PortalPageHeader from '../../../components/portal/PortalPageHeader';
import { PortalEmptyState } from '../../../components/portal/PortalStates';
import { CK, sectionCardSx } from '../portalStyles';

const getDisplayNameFromEmail = (email) => {
  if (!email) return 'User';
  const localPart = email.split('@')[0];
  return localPart
    .replace(/[._-]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const CloudTrailDashboard = () => {
  const user = getPortalUser();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
    >
      {/* Header */}
      <motion.div variants={sectionVariants}>
        <PortalPageHeader
          icon={<CloudIcon />}
          title={`Welcome${user?.email ? `, ${getDisplayNameFromEmail(user.email)}` : ''}`}
          subtitle="Manage AWS CloudTrail centrally across all accounts in your organization"
          color="#4698D3"
        />
      </motion.div>

      {/* Placeholder */}
      <motion.div variants={sectionVariants}>
        <Paper
          elevation={0}
          sx={{ ...sectionCardSx, p: { xs: 3, sm: 4 } }}
        >
          <PortalEmptyState
            icon={<CloudIcon sx={{ fontSize: 28 }} />}
            title="CloudTrail"
            description="CloudTrail management is coming soon — you'll be able to view and manage CloudTrail configuration for every account in your organization from here."
            color={CK.blue}
          />
        </Paper>
      </motion.div>
    </motion.div>
  );
};

export default CloudTrailDashboard;
